import React from 'react'
import { SelectComponent } from '../../shared/select/select.component'


export class PaymentsConds extends React.Component {
  constructor(props) {
    super(props)
    this.changedPayType = this.changedPayType.bind(this)
  }

  changedPayType(e) {
    const payTypeId = e.target.value
    const payType = (this.props.payTypes || []).find(pt => pt.id == payTypeId)
    this.props.onChange(payTypeId, payType ? payType.system_name : 'cash')
  }

  render() {
    if(this.props.settings.payment_system == 'turned_off' || this.props.settings.mobile_only_payment)
      return null
    const payTypes = this.props.payTypes
    if(!payTypes || payTypes.length == 0)
      return null

    return (
      <div>
        <div className="h4">
          Оплата
        </div>

        <SelectComponent
          opts={payTypes}
          value={this.props.payTypeId}
          onChange={this.changedPayType}
        />
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./app/javascript/website_default/js/react/cart/make_order/payments_conds.component.jsx